import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CheckInMutationVariables = Types.Exact<{
  checkinInput: Types.CheckinInput;
}>;

export type CheckInMutation = {
  __typename?: "Mutation";
  checkin: { __typename?: "Checkin"; wasSuccessful: boolean };
};

export type CancelCheckInMutationVariables = Types.Exact<{
  cancelCheckinInput: Types.CancelCheckinInput;
}>;

export type CancelCheckInMutation = {
  __typename?: "Mutation";
  cancelCheckin: { __typename?: "CancelOutput"; success: boolean };
};

export type CancelReservationMutationVariables = Types.Exact<{
  cancelReservationInput: Types.CancelReservationInput;
}>;

export type CancelReservationMutation = {
  __typename?: "Mutation";
  cancelReservation: { __typename?: "Registration"; uuid: string };
};

export type RemoveLateCancelMutationVariables = Types.Exact<{
  removeLateCancelInput: Types.CancelReservationInput;
}>;

export type RemoveLateCancelMutation = {
  __typename?: "Mutation";
  removeLateCancel: { __typename?: "CancelOutput"; success: boolean };
};

export type RemoveFromWaitListMutationVariables = Types.Exact<{
  cancelReservationInput: Types.CancelReservationInput;
}>;

export type RemoveFromWaitListMutation = {
  __typename?: "Mutation";
  removeFromWaitlist: { __typename?: "Registration"; uuid: string };
};

export type BulkCheckinMutationVariables = Types.Exact<{
  bulkCheckinInput: Types.BulkCheckinInput;
}>;

export type BulkCheckinMutation = {
  __typename?: "Mutation";
  bulkCheckin: {
    __typename?: "BulkCheckinResult";
    failedCheckins: Array<{
      __typename?: "FailedCheckin";
      reservationId: string;
      reason: string;
    }>;
  };
};

export const CheckInDocument = gql`
  mutation CheckIn($checkinInput: CheckinInput!) {
    checkin(checkinInput: $checkinInput) {
      wasSuccessful
    }
  }
`;
export type CheckInMutationFn = Apollo.MutationFunction<
  CheckInMutation,
  CheckInMutationVariables
>;

/**
 * __useCheckInMutation__
 *
 * To run a mutation, you first call `useCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkInMutation, { data, loading, error }] = useCheckInMutation({
 *   variables: {
 *      checkinInput: // value for 'checkinInput'
 *   },
 * });
 */
export function useCheckInMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CheckInMutation,
    CheckInMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CheckInMutation, CheckInMutationVariables>(
    CheckInDocument,
    options,
  );
}
export type CheckInMutationHookResult = ReturnType<typeof useCheckInMutation>;
export type CheckInMutationResult = Apollo.MutationResult<CheckInMutation>;
export type CheckInMutationOptions = Apollo.BaseMutationOptions<
  CheckInMutation,
  CheckInMutationVariables
>;
export const CancelCheckInDocument = gql`
  mutation CancelCheckIn($cancelCheckinInput: CancelCheckinInput!) {
    cancelCheckin(cancelCheckinInput: $cancelCheckinInput) {
      success
    }
  }
`;
export type CancelCheckInMutationFn = Apollo.MutationFunction<
  CancelCheckInMutation,
  CancelCheckInMutationVariables
>;

/**
 * __useCancelCheckInMutation__
 *
 * To run a mutation, you first call `useCancelCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCheckInMutation, { data, loading, error }] = useCancelCheckInMutation({
 *   variables: {
 *      cancelCheckinInput: // value for 'cancelCheckinInput'
 *   },
 * });
 */
export function useCancelCheckInMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelCheckInMutation,
    CancelCheckInMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelCheckInMutation,
    CancelCheckInMutationVariables
  >(CancelCheckInDocument, options);
}
export type CancelCheckInMutationHookResult = ReturnType<
  typeof useCancelCheckInMutation
>;
export type CancelCheckInMutationResult =
  Apollo.MutationResult<CancelCheckInMutation>;
export type CancelCheckInMutationOptions = Apollo.BaseMutationOptions<
  CancelCheckInMutation,
  CancelCheckInMutationVariables
>;
export const CancelReservationDocument = gql`
  mutation CancelReservation($cancelReservationInput: CancelReservationInput!) {
    cancelReservation(cancelReservationInput: $cancelReservationInput) {
      uuid
    }
  }
`;
export type CancelReservationMutationFn = Apollo.MutationFunction<
  CancelReservationMutation,
  CancelReservationMutationVariables
>;

/**
 * __useCancelReservationMutation__
 *
 * To run a mutation, you first call `useCancelReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReservationMutation, { data, loading, error }] = useCancelReservationMutation({
 *   variables: {
 *      cancelReservationInput: // value for 'cancelReservationInput'
 *   },
 * });
 */
export function useCancelReservationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelReservationMutation,
    CancelReservationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelReservationMutation,
    CancelReservationMutationVariables
  >(CancelReservationDocument, options);
}
export type CancelReservationMutationHookResult = ReturnType<
  typeof useCancelReservationMutation
>;
export type CancelReservationMutationResult =
  Apollo.MutationResult<CancelReservationMutation>;
export type CancelReservationMutationOptions = Apollo.BaseMutationOptions<
  CancelReservationMutation,
  CancelReservationMutationVariables
>;
export const RemoveLateCancelDocument = gql`
  mutation RemoveLateCancel($removeLateCancelInput: CancelReservationInput!) {
    removeLateCancel(removeLateCancelInput: $removeLateCancelInput) {
      success
    }
  }
`;
export type RemoveLateCancelMutationFn = Apollo.MutationFunction<
  RemoveLateCancelMutation,
  RemoveLateCancelMutationVariables
>;

/**
 * __useRemoveLateCancelMutation__
 *
 * To run a mutation, you first call `useRemoveLateCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLateCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLateCancelMutation, { data, loading, error }] = useRemoveLateCancelMutation({
 *   variables: {
 *      removeLateCancelInput: // value for 'removeLateCancelInput'
 *   },
 * });
 */
export function useRemoveLateCancelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveLateCancelMutation,
    RemoveLateCancelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveLateCancelMutation,
    RemoveLateCancelMutationVariables
  >(RemoveLateCancelDocument, options);
}
export type RemoveLateCancelMutationHookResult = ReturnType<
  typeof useRemoveLateCancelMutation
>;
export type RemoveLateCancelMutationResult =
  Apollo.MutationResult<RemoveLateCancelMutation>;
export type RemoveLateCancelMutationOptions = Apollo.BaseMutationOptions<
  RemoveLateCancelMutation,
  RemoveLateCancelMutationVariables
>;
export const RemoveFromWaitListDocument = gql`
  mutation RemoveFromWaitList(
    $cancelReservationInput: CancelReservationInput!
  ) {
    removeFromWaitlist(removeFromWaitlistInput: $cancelReservationInput) {
      uuid
    }
  }
`;
export type RemoveFromWaitListMutationFn = Apollo.MutationFunction<
  RemoveFromWaitListMutation,
  RemoveFromWaitListMutationVariables
>;

/**
 * __useRemoveFromWaitListMutation__
 *
 * To run a mutation, you first call `useRemoveFromWaitListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromWaitListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromWaitListMutation, { data, loading, error }] = useRemoveFromWaitListMutation({
 *   variables: {
 *      cancelReservationInput: // value for 'cancelReservationInput'
 *   },
 * });
 */
export function useRemoveFromWaitListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveFromWaitListMutation,
    RemoveFromWaitListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveFromWaitListMutation,
    RemoveFromWaitListMutationVariables
  >(RemoveFromWaitListDocument, options);
}
export type RemoveFromWaitListMutationHookResult = ReturnType<
  typeof useRemoveFromWaitListMutation
>;
export type RemoveFromWaitListMutationResult =
  Apollo.MutationResult<RemoveFromWaitListMutation>;
export type RemoveFromWaitListMutationOptions = Apollo.BaseMutationOptions<
  RemoveFromWaitListMutation,
  RemoveFromWaitListMutationVariables
>;
export const BulkCheckinDocument = gql`
  mutation BulkCheckin($bulkCheckinInput: BulkCheckinInput!) {
    bulkCheckin(bulkCheckinInput: $bulkCheckinInput) {
      failedCheckins {
        reservationId
        reason
      }
    }
  }
`;
export type BulkCheckinMutationFn = Apollo.MutationFunction<
  BulkCheckinMutation,
  BulkCheckinMutationVariables
>;

/**
 * __useBulkCheckinMutation__
 *
 * To run a mutation, you first call `useBulkCheckinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCheckinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCheckinMutation, { data, loading, error }] = useBulkCheckinMutation({
 *   variables: {
 *      bulkCheckinInput: // value for 'bulkCheckinInput'
 *   },
 * });
 */
export function useBulkCheckinMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkCheckinMutation,
    BulkCheckinMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkCheckinMutation, BulkCheckinMutationVariables>(
    BulkCheckinDocument,
    options,
  );
}
export type BulkCheckinMutationHookResult = ReturnType<
  typeof useBulkCheckinMutation
>;
export type BulkCheckinMutationResult =
  Apollo.MutationResult<BulkCheckinMutation>;
export type BulkCheckinMutationOptions = Apollo.BaseMutationOptions<
  BulkCheckinMutation,
  BulkCheckinMutationVariables
>;
